export default "__VITE_ASSET__DeSVO9ja__"